<template>
	<div>
		<a href="#" class="btn-group" data-tab-btn="options-toolbar" data-tab-group="options-bar"><i class="fa fa-plus"></i>
			Set options</a>
		<div class="group" data-tab-body="options-toolbar" data-tab-group="options-bar">

			<ul class="form">
				<li>
					<label>Endpoint data to reference to:</label>
					<input type="text" name="property.settings.endpoint.value" :value="endpoint">
				</li>
			</ul>

			<ul class="form">
				<li>

					<table class="list sortable-list">
						<thead>
							<tr>
								<th></th>
								<th>Key</th>
								<th v-for="lang in languages" :key="lang.id">{{lang.language}} <span v-if="lang.region">({{lang.region}})</span></th>
								<th>
									<a href="#" class="btn-option-add" v-on:click="addOptionClickHandler">
										<i class="fa fa-plus"></i>
									</a>
								</th>
							</tr>
						</thead>
						<tbody class="draggable-container main-draggable-container">
							<tr v-for="(option, index) in optionsArr" :key="index" class="draggable-item" :class="{ 'hidden' : option[1].state === 5}" :data-id="option[1].id">
								<td class="handle">
									<div class="grip"></div>
								</td>
								<template>
									<td>
										<input type="hidden" :name="`options.${option[0]}.id`" v-model="option[1].id">
										<input type="hidden" :name="`options.${option[0]}.priority`" v-model="option[1].priority">
										<input type="hidden" :name="`options.${option[0]}.state`" v-model="option[1].state">
										<input type="text" :name="`options.${option[0]}.value`" v-model="option[1].value">
									</td>
									<td v-for="lang in languages" :key="lang.id">
										<input type="text" :name="`options.${option[0]}.translations.${lang.locale}.value`" v-model="option[1].translations[lang.locale].value">
									</td>
									<td>
										<a href="#" class="btn-option-min" :data-index="option[0]" v-on:click="removeOptionClickHandler">
											<i class="fa fa-minus"></i>
										</a>
									</td>
								</template>
							</tr>
						</tbody>
					</table>

				</li>
			</ul>

		</div>
	</div>
</template>

<script>

import sortable from '../../../modules/sortable.js'

export default {
	name: 'OptionsConfigurator',

	props: {
		languages: Object,
		endpoint: String,
		options: Object
	},

	watch: {
		languages: function (newVal, oldVal) {
			this.createSortedArray()
		}
	},

	data () {
		return {
			optionInt: 0,
			optionsArr: []
		}
	},

	updated () {
		this.enableUISort()
		this.sortCompleted()
	},

	beforeDestroy () {
		this.sortableModule.destroy()
		this.sortActive = false
	},

	methods: {
		createSortedArray () {
			// In case there are new languages added after the creation of these options we need to add the new locales to the list
			const tempOptions = Object.entries(this.options)
			for (var i = 0; i < tempOptions.length; i++) {
				for (var lang in this.languages) {
					if (!tempOptions[i][1].translations[this.languages[lang].locale]) {
						tempOptions[i][1].translations[this.languages[lang].locale] = {
							id: 0,
							market: this.languages[lang],
							state: 3,
							value: ''
						}
					}
				}

				if (i === tempOptions.length - 1) {
					tempOptions.sort(function (a, b) {
						return a[1].priority - b[1].priority
					})

					this.optionsArr = tempOptions
				}
			}
		},

		addOptionClickHandler (e) {
			e.preventDefault()

			this.optionInt++

			var option = {
				'id': 'tempoption-' + this.optionInt,
				'value': '',
				'priority': 9999,
				'state': 3
			}

			option['translations'] = {}
			for (var lang in this.languages) {
				option['translations'][this.languages[lang].locale] = {
					'id': 0,
					'value': '',
					'market': this.languages[lang].id
				}
			}

			this.options['tempoption-' + this.optionInt] = option
			this.createSortedArray()
			this.$forceUpdate()
		},

		removeOptionClickHandler (e) {
			e.preventDefault()

			var index = e.currentTarget.getAttribute('data-index')
			var opt = this.options[index].id.toString()
			if (opt.includes('tempoption-')) {
				delete this.options[index]
			} else {
				this.options[index].state = 5
			}
			this.createSortedArray()
			this.$forceUpdate()
		},

		enableUISort () {
			// destroy for previous instance of sortable
			if (this.sortActive) {
				this.sortableModule.destroy()
				this.sortActive = false
			}

			// enable UI sorting
			var container = this.$el.querySelector('.draggable-container')
			if (container && !this.sortActive) {
				this.sortActive = true
				this.sortableModule = sortable({
					container: null,
					form: true,
					callback: this.sortCompleted.bind(this),
					nestable: false,
					collapsible: false
				})
				this.sortableModule.init()
			}
		},

		sortCompleted: function () {
			// recalc priorities
			var items = this.$el.querySelectorAll('.main-draggable-container tr')
			for (var i = items.length - 1; i >= 0; i--) {
				var optionKey = items[i].getAttribute('data-id')
				// change priority
				for (var o = this.optionsArr.length - 1; o >= 0; o--) {
					if (this.optionsArr[o][1].id == optionKey) {
						this.optionsArr[o][1].priority = i + 1
					}
				}
			}
		}
	}
}

</script>
